import { RootState } from '@/shared/store'
import { createSelector, EntityId } from '@reduxjs/toolkit'

import { runsheetStopsAdapter } from '../adapters/runsheetStopsAdapter'

export const runsheetStopsSelectors = runsheetStopsAdapter.getSelectors<RootState>(
  (state) => state.runsheetStops,
)

export const selectRunsheetStopsByIds = createSelector(
  [runsheetStopsSelectors.selectEntities, (_, ids: EntityId[]) => ids],
  (runsheetStops, ids) => {
    return ids?.map(id => runsheetStops?.[id] || null)
      ?.filter(stop => stop != null)
      ?.sort((a, b) => a.sequence - b.sequence)
      || []
  },
)
